import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import type {
  ISignalProviderDetailResponse,
  ISignalProviderListResponse,
} from '@brushfire/types'

export async function fetchSignalProviderList(): Promise<ISignalProviderListResponse> {
  const { data } = await apiClient.get<ApiResponse<ISignalProviderListResponse>>(
    '/api/v1/platform/signal-providers',
  )
  if (!data.data) {
    throw new Error('Signal provider list response missing data')
  }
  return data.data
}

export async function fetchSignalProviderDetail(
  platformUserId: string,
): Promise<ISignalProviderDetailResponse> {
  const { data } = await apiClient.get<ApiResponse<ISignalProviderDetailResponse>>(
    `/api/v1/platform/signal-providers/${encodeURIComponent(platformUserId)}`,
  )
  if (!data.data) {
    throw new Error('Signal provider detail response missing data')
  }
  return data.data
}
